<script lang="ts">import { stateUi } from "@infinitro/config";
import AccordionAlternative2 from "./accordion-alternative2.svelte";
import AccordionDefault from "./accordion-default.svelte";
let props = $props();
const useAlternative2 = $derived($stateUi.accordion?.accordionStyle === "alternative2" || props.useAlternative2Design);
</script>

{#if useAlternative2}
	<AccordionAlternative2 {...props} />
{:else}
	<AccordionDefault {...props} />
{/if}
